import { projectConfig } from "../project-info/projectConfig";
import { isInternalURL } from "./Helpers";

export function handleLinkClick(url) {
    if (isInternalURL(url)) {
        window.open(url, "_self");
    }
    else {
        window.open(url, '_blank');
    }
}
